module.exports = __webpack_public_path__ + "fonts/pictonic.woff";


//////////////////
// WEBPACK FOOTER
// ./app/styles/pictonic/font/pictonic.woff
// module id = 454
// module chunks = 0